module.exports = __webpack_public_path__ + "static/barbarian-wulfgar-AYAGWW-2e9fc8ddb7b8ef8ea00c58094128e5ed.png";